module.exports = __webpack_public_path__ + "static/media/DubaiW23-Light.e378285e.ttf";